module.exports = __webpack_public_path__ + "img/hr-level1_mining_tool_shadow-2.a28517f4.png";